<template>
  <div
    v-if="mostrar"
    class="modal fade show modal-avaliacao-wrapper"
    style="display: block; z-index: 9999;"
    tabindex="-1"
    role="dialog"
    @click.self="fecharModal"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable" role="document" @click.stop style="z-index: 10000;">
      <div class="modal-content modal-avaliacao">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="fecharModal"
            :disabled="enviando"
          >
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="error" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>

          <div v-if="!enviadoComSucesso">
            <!-- Etapa 1: Estado, Cidade, Função e Instagram -->
            <div v-if="etapa === 1">
              <ValidationObserver ref="observer" v-slot="{ validate }">
                <div class="text-center mb-4">
                  <h4 class="font-weight-bold">Avaliação do nosso {{ nomeOficina || 'TREINAMENTO' }}</h4>
                  <p class="text-muted"><strong>Olá!👋 Seja bem vindo ou bem vinda. 😍</strong></p>
                  <p class="text-muted">Por gentileza, nos forneça um feedback com sua avaliação sobre este treinamento.</p>
                  <p class="text-muted">Desde já, agradecemos a você pela motivação e interesse por este conteúdo tão importante para o desenvolvimento da saúde digital na APS.</p>
                </div>
                <div class="form-row mb-4">
                  <div class="form-group col-md-6">
                    <label class="font-weight-bold text-muted small mb-2">ESTADO</label>
                    <div class="info-badge">
                      <i class="icofont-location-pin mr-2"></i>
                      <span class="info-value">{{ form.estadoTexto || '-' }}</span>
                    </div>
                  </div>
                  <div class="form-group col-md-6">
                    <label class="font-weight-bold text-muted small mb-2">CIDADE</label>
                    <div class="info-badge">
                      <i class="icofont-building mr-2"></i>
                      <span class="info-value">{{ form.cidadeTexto || '-' }}</span>
                    </div>
                  </div>
                </div>
                <div class="form-row mt-4">
                  <div class="form-group col-12 col-md-6">
                    <label for="funcao" class="font-weight-bold text-muted small mb-2">
                      <i class="icofont-briefcase mr-1"></i>FUNÇÃO
                    </label>
                    <ValidationProvider name="Função" rules="required" v-slot="{ errors }">
                      <vue-select
                        :options="funcoes"
                        placeholder="Selecione sua ocupação"
                        v-model="form.funcao"
                        @input="verificarFuncao"
                        class="vue-select"
                      ></vue-select>
                      <span v-if="errors.length" class="text-danger small d-block mt-1">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="form-group col-12 col-md-6">
                    <label for="ubs" class="font-weight-bold text-muted small mb-2">
                      <i class="icofont-hospital mr-1"></i>LOCAL DE TRABALHO
                    </label>
                    <ValidationProvider name="UBS" :rules="mostrarUBS ? 'required' : ''" v-slot="{ errors }">
                      <vue-select
                        :options="ubs"
                        :placeholder="mostrarUBS ? 'Selecione um local' : 'Opcional: selecione um local'"
                        v-model="form.ubs"
                        label="no_ubs"
                        @input="verificarUBS"
                        class="vue-select"
                        :disabled="ubs.length === 0"
                      ></vue-select>
                      <span v-if="errors.length" class="text-danger small d-block mt-1">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="form-group mt-4">
                  <label for="instagram" class="font-weight-bold text-muted small mb-2">
                    <i class="icofont-instagram mr-1"></i>INSTAGRAM
                  </label>
                  <p class="small text-muted mb-2">Por favor, informe seu Instagram para que possamos mencioná-lo na postagem em nossa página sobre este treinamento.
                  </p>
                  <ValidationProvider name="Instagram" v-slot="{ errors }">
                    <div class="form-row">
                      <div class="col-12 col-md-6">
                        <div class="input-wrapper">
                          <i class="icofont-at-sign input-icon"></i>
                          <input 
                            id="instagram" 
                            class="form-control input-with-icon" 
                            v-model="form.instagram" 
                            placeholder="@seuinstagram"
                          />
                        </div>
                      </div>
                    </div>
                    <span v-if="errors.length" class="text-danger small d-block mt-1">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-actions mt-3">
                  <button type="button" @click="proximaEtapa(2, validate)" class="btn btn-primary btn-proximo">Próximo</button>
                </div>
              </ValidationObserver>
            </div>

            <!-- Etapa 2: SUS Digital (agora etapa 2) -->

            <!-- Etapa 2: SUS Digital -->
            <div v-if="etapa === 2">
              <ValidationObserver ref="observer" v-slot="{ validate }">
                <div class="form-group mt-3">
                  <label>Você conhece o Programa SUS DIGITAL?</label>
                  <ValidationProvider name="Programa SUS DIGITAL" rules="required" v-slot="{ errors }">
                    <div class="btn-group">
                      <v-btn
                        :class="{'btn-active': form.conhece_sus_digital === 'sim'}"
                        @click="setConheceSUSDigital('sim')"
                        depressed
                      >
                        Sim
                      </v-btn>
                      <v-btn
                        :class="{'btn-active': form.conhece_sus_digital === 'nao'}"
                        @click="setConheceSUSDigital('nao')"
                        depressed
                      >
                        Não
                      </v-btn>
                      <input type="hidden" v-model="form.conhece_sus_digital" />
                    </div>
                    <span v-if="errors.length" class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group mt-3" v-if="form.conhece_sus_digital === 'sim'">
                  <label for="descricao_compreensao_usuario">Poderia descrever brevemente sua compreensão do programa?</label>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <textarea id="descricao_compreensao_usuario" rows="4" class="form-control" v-model="form.descricao_compreensao_usuario"></textarea>
                    <span v-if="errors.length" class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <SpeechRecognition :targetModel.sync="form.descricao_compreensao_usuario" />
                </div>
                <div class="form-group mt-3" v-if="form.conhece_sus_digital === 'sim'">
                  <label for="uso_sus_digital_trabalho">De que maneira você gostaria de utilizar o SUS DIGITAL em seu trabalho diário para facilitar seu dia a dia e melhorar o atendimento ao cidadão?</label>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <textarea id="uso_sus_digital_trabalho" rows="4" class="form-control" v-model="form.uso_sus_digital_trabalho"></textarea>
                    <span v-if="errors.length" class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <SpeechRecognition :targetModel.sync="form.uso_sus_digital_trabalho" />
                </div>
                <div class="form-actions mt-3">
                  <button type="button" @click="anteriorEtapa" class="btn btn-secondary">Anterior</button>
                  <button type="button" @click="proximaEtapa(3, validate)" class="btn btn-primary btn-proximo">Próximo</button>
                </div>
              </ValidationObserver>
            </div>

            <!-- Etapa 3: Opinião, Data e Sugestão -->
            <div v-if="etapa === 3">
              <ValidationObserver ref="observer" v-slot="{ validate }">
                <div class="form-group mt-3">
                  <label for="opiniaoTreinamento">Qual é a sua opinião sobre este treinamento? Por favor, comente sobre os aspectos positivos e negativos, e sugira possíveis melhorias.</label>
                  <ValidationProvider name="Opinião Treinamento" rules="required" v-slot="{ errors }">
                    <textarea id="opiniaoTreinamento" rows="4" class="form-control" v-model="form.opiniaoTreinamento" required></textarea>
                    <span v-if="errors.length" class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <SpeechRecognition :targetModel.sync="form.opiniaoTreinamento" />
                </div>
                <div class="form-group mt-3">
                  <label for="dataTreinamento" class="d-block mb-2">Data do treinamento</label>
                  <ValidationProvider name="Data Treinamento" rules="required" v-slot="{ errors }">
                    <div class="input-date-wrapper position-relative">
                      <input
                        type="text"
                        id="dataTreinamento"
                        class="form-control date-input"
                        v-model="dataTreinamentoFormatada"
                        placeholder="dd/mm/aaaa"
                        @input="formatarDataTreinamento"
                        required
                      />
                      <input
                        ref="datePickerTreinamento"
                        type="date"
                        class="date-picker-hidden"
                        v-model="form.dt_treinamento"
                        @change="onDatePickerTreinamentoChange"
                      />
                      <i 
                        class="icofont-calendar date-icon" 
                        @click="abrirDatePickerTreinamento"
                        title="Selecionar data"
                      ></i>
                    </div>
                    <span v-if="errors.length" class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="form-group mt-3">
                  <label for="sugestao_tema">Informe o tema de treinamento que você gostaria de receber para aprimorar suas habilidades na área da saúde digital.</label>
                  <ValidationProvider name="Tema Treinamento" rules="required" v-slot="{ errors }">
                    <textarea id="sugestao_tema" rows="4" class="form-control" v-model="form.sugestao_tema" required></textarea>
                    <span v-if="errors.length" class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <SpeechRecognition :targetModel.sync="form.sugestao_tema" />
                </div>
                <div class="form-actions mt-3">
                  <button type="button" @click="anteriorEtapa" class="btn btn-secondary">Anterior</button>
                  <button type="button" @click="proximaEtapa(4, validate)" class="btn btn-primary btn-proximo">Próximo</button>
                </div>
              </ValidationObserver>
            </div>

            <!-- Etapa 4: NPS (última etapa) -->
            <ValidationObserver ref="observerNps" v-slot="{ validate }">
              <Nps v-if="etapa === 4" @anterior-etapa="anteriorEtapa" @proxima-etapa="() => enviarFormulario(validate)" @update:nps="form.nps = $event" @update:escala="form.escala = $event" />
            </ValidationObserver>
          </div>

          <!-- Mensagem de Sucesso -->
          <div v-if="enviadoComSucesso" class="text-center">
            <h4 class="font-weight-bold mb-3">Obrigado por sua participação!</h4>
            <p>Agradecemos seu feedback sobre o treinamento.</p>
            <p>Sua opinião é essencial para nós e nos ajuda a aprimorar continuamente nossos programas.</p>
            <p>AbraSUS! 👏</p>
            <button type="button" @click="fecharModal" class="btn btn-primary mt-3">Fechar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show modal-backdrop-avaliacao"></div>

    <!-- Modal de Termos -->
    <ModalTermos v-if="showModalTermos" @close-modal-termos="closeModalTermos" @aceitar-termos="aceitarTermos" />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'
import { apiPublic } from '@/plugins/axios.js'
import ModalTermos from '@/components/ModalTermos'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import SpeechRecognition from '@/pages/AvaliacaoTreinamento/components/SpeechRecognition.vue'
import Nps from '@/pages/AvaliacaoTreinamento/Nps.vue'
import { jwtDecode } from 'jwt-decode'

extend('requiredCheckbox', {
  validate: value => {
    return value === true
  },
  message: 'Você deve aceitar os Termos de uso'
})

extend('required', {
  ...required,
  message: 'Campo obrigatório'
})

export default {
  name: 'ModalAvaliacao',
  components: {
    ValidationObserver,
    ValidationProvider,
    ModalTermos,
    'vue-select': VueSelect,
    SpeechRecognition,
    Nps
  },
  props: {
    mostrar: {
      type: Boolean,
      default: false
    },
    oficinaId: {
      type: [Number, String],
      default: null
    },
    nomeOficina: {
      type: String,
      default: ''
    },
    oficina: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      form: {
        estado: '',
        cidade: '',
        cidadeSelecionada: null,
        estadoTexto: '',
        cidadeTexto: '',
        municipioCompleto: '',
        funcao: '',
        ubs: '',
        instagram: '',
        conhece_sus_digital: '',
        descricao_compreensao_usuario: '',
        uso_sus_digital_trabalho: '',
        opiniaoTreinamento: '',
        sugestao_tema: '',
        dt_treinamento: '',
        dataTreinamentoFormatada: '',
        nps: null,
        escala: '',
        termos: true
      },
      estados: [
        { uf: 'AC' }, { uf: 'AL' }, { uf: 'AP' }, { uf: 'AM' }, { uf: 'BA' }, { uf: 'CE' }, { uf: 'DF' },
        { uf: 'ES' }, { uf: 'GO' }, { uf: 'MA' }, { uf: 'MT' }, { uf: 'MS' }, { uf: 'MG' }, { uf: 'PA' },
        { uf: 'PB' }, { uf: 'PR' }, { uf: 'PE' }, { uf: 'PI' }, { uf: 'RJ' }, { uf: 'RN' }, { uf: 'RS' },
        { uf: 'RO' }, { uf: 'RR' }, { uf: 'SC' }, { uf: 'SP' }, { uf: 'SE' }, { uf: 'TO' }
      ],
      cidades: [],
      funcoes: [
        { label: 'Administrador e-SUS PEC', value: 'Administrador e-SUS PEC' },
        { label: 'Agente Comunitário de Saúde', value: 'Agente Comunitário de Saúde' },
        { label: 'ACE (Agente Comunitário de Endemias)', value: 'ACE (Agente Comunitário de Endemias)' },
        { label: 'Aux/Téc Enfermagem', value: 'Aux/Téc Enfermagem' },
        { label: 'Coordenador(a) de Imunização', value: 'Coordenador(a) de Imunização' },
        { label: 'Coordenador(a) de Vigilância em Saúde', value: 'Coordenador(a) de Vigilância em Saúde' },
        { label: 'Gerente/Coordenador(a)', value: 'Gerente/Coordenador(a)' },
        { label: 'Enfermeiro(a)', value: 'Enfermeiro(a)' },
        { label: 'Enfermeiro(a) / Médico(a)', value: 'Enfermeiro(a) / Médico(a)' },
        { label: 'Fármacia e outros', value: 'Fármacia e outros' },
        { label: 'Médico(a)', value: 'Médico(a)' },
        { label: 'Odontólogo(a)', value: 'Odontólogo(a)' },
        { label: 'Profissional da eMulti', value: 'Profissional da eMulti' },
        { label: 'Recepcionista', value: 'Recepcionista' },
        { label: 'Secretário(a)', value: 'Secretário(a)' },
        { label: 'Suporte eSUS Feedback', value: 'Suporte eSUS Feedback' },
        { label: 'Téc. Aux de Saúde Bucal', value: 'Téc. Aux de Saúde Bucal' },
        { label: 'Vacinador(a)', value: 'Vacinador(a)' }
      ],
      ubs: [],
      funcoesEspecificas: [
        'Agente Comunitário de Saúde', 
        'Aux/Téc Enfermagem', 
        'Enfermeiro(a)', 
        'Médico(a)',
        'Odontólogo(a)', 
        'Recepcionista', 
        'Téc. Aux de Saúde Bucal',
        'Secretário(a)',
        'Gerente/Coordenador(a)'
      ],
      etapa: 1,
      showModalTermos: false,
      loading: false,
      error: false,
      errorMessage: '',
      enviadoComSucesso: false,
      enviando: false,
      cpf: null
    }
  },
  computed: {
    mostrarUBS() {
      if (!this.form.funcao) {
        return false
      }
      const precisaUBS = this.funcoesEspecificas.some(f => {
        const funcaoLower = this.form.funcao.toLowerCase()
        const fLower = f.toLowerCase()
        return f === this.form.funcao || 
               funcaoLower.includes(fLower) || 
               fLower.includes(funcaoLower)
      })
      return precisaUBS
    }
  },
  watch: {
    mostrar(newVal) {
      if (newVal) {
        this.resetFormulario()
        this.buscarCpfUsuario()
        this.preencherEstadoCidadeDoToken()
        this.preencherFuncaoDoUsuario()
        this.$nextTick(() => {
          this.preencherDataTreinamento()
        })
      }
    },
    oficina: {
      handler(newVal) {
        if (newVal && this.mostrar && this.form.dt_treinamento === '') {
          this.preencherDataTreinamento()
        }
      },
      immediate: true
    }
  },
  methods: {
    async buscarCidades(event) {
      if (!event || !event.uf) {
        this.cidades = []
        this.form.cidade = ''
        this.form.cidadeSelecionada = null
        return
      }

      this.loading = true
      this.error = false
      this.form.cidade = ''
      this.form.cidadeSelecionada = null
      try {
        const response = await apiPublic.get(`/cidades-por-uf/${event.uf}`)
        this.cidades = response.data
      } catch (error) {
        this.cidades = []
        this.error = true
        this.errorMessage = 'Erro ao buscar cidades. Por favor, tente novamente mais tarde.'
      } finally {
        this.loading = false
      }
    },
    verificarCidade(cidade) {
      const cidadeSelecionada = this.cidades.find(c => c.no_municipio === cidade.no_municipio)
      if (cidadeSelecionada) {
        this.form.cidadeSelecionada = cidadeSelecionada
      } else {
        this.form.cidadeSelecionada = null
      }
    },
    async verificarFuncao(event) {
      const funcaoValue = event && typeof event === 'object' && event.value ? event.value : event
      this.form.funcao = funcaoValue
      
      const cidadeSelecionada = this.form.cidadeSelecionada
      const ibgeParaBuscar =
        (cidadeSelecionada && cidadeSelecionada.co_ibge) ? cidadeSelecionada.co_ibge : this.$store.state.cod_ibge

      if (!ibgeParaBuscar) {
        this.ubs = []
        return
      }

      try {
        const response = await apiPublic.get(`/cofinanciamento-2024/ubs/${ibgeParaBuscar}`)
        this.ubs = Array.isArray(response.data) ? response.data : []

        if (!this.ubs.some(u => String(u?.no_ubs || '').toLowerCase() === 'outros')) {
          this.ubs.push({ no_ubs: 'Outros' })
        }
      } catch (error) {
        this.ubs = []
        this.error = true
        this.errorMessage = 'Erro ao buscar UBSs. Por favor, tente novamente mais tarde.'
      }
    },
    verificarUBS() {
      const noUbs = this.form.ubs && typeof this.form.ubs === 'object' ? this.form.ubs.no_ubs : this.form.ubs
      const ubsSelecionada = this.ubs.find(ubs => ubs.no_ubs === noUbs)
      if (ubsSelecionada) {
        this.form.ubs = ubsSelecionada
      }
    },
    setConheceSUSDigital(value) {
      this.form.conhece_sus_digital = value
      this.$nextTick(() => {
        this.$refs.observer.validate()
      })
    },
    async proximaEtapa(etapa, validate) {
      if (!validate) {
        this.etapa = etapa
        return
      }
      const isValid = await validate()
      if (isValid) {
        this.etapa = etapa
      }
    },
    anteriorEtapa() {
      if (this.etapa > 1) {
        this.etapa -= 1
      }
    },
    resetFormulario() {
      this.etapa = 1
      this.enviadoComSucesso = false
      this.error = false
      this.errorMessage = ''
      this.form = {
        estado: '',
        cidade: '',
        cidadeSelecionada: null,
        estadoTexto: '',
        cidadeTexto: '',
        municipioCompleto: '',
        funcao: '',
        ubs: '',
        instagram: '',
        conhece_sus_digital: '',
        descricao_compreensao_usuario: '',
        uso_sus_digital_trabalho: '',
        opiniaoTreinamento: '',
        sugestao_tema: '',
        dt_treinamento: '',
        dataTreinamentoFormatada: '',
        nps: null,
        escala: '',
        termos: true
      }
      this.cidades = []
      this.ubs = []
    },
    async enviarFormulario(validate) {
      const isValid = await validate()
      if (isValid) {
        this.enviando = true
        const municipio = this.form.municipioCompleto || 
          (this.form.cidade && this.form.estado 
            ? `${this.form.cidade.no_municipio || this.form.cidadeTexto} - ${this.form.estado.uf || this.form.estadoTexto}`
            : this.$store.state.cidade || '')
        
        const cpfLimpo = this.cpf ? String(this.cpf).replace(/\D/g, '') : null

        const formData = {
          id_oficina_treinamento: this.oficinaId,
          ibge: this.form.cidadeSelecionada?.co_ibge || this.$store.state.cod_ibge || '',
          municipio: municipio,
          cnes: this.form.ubs?.cnes ? this.form.ubs.cnes : null,
          ubs: this.form.ubs?.no_ubs ? this.form.ubs.no_ubs : null,
          cpf: cpfLimpo,
          dados: {
            funcao: this.form.funcao,
            instagram: this.form.instagram,
            conhece_sus_digital: this.form.conhece_sus_digital,
            descricao_compreensao_usuario: this.form.descricao_compreensao_usuario,
            uso_sus_digital_trabalho: this.form.uso_sus_digital_trabalho,
            opiniaoTreinamento: this.form.opiniaoTreinamento,
            sugestao_tema: this.form.sugestao_tema,
            dt_treinamento: this.form.dt_treinamento,
            termos: this.form.termos,
            nps: this.form.nps,
            escala: this.form.escala
          }
        }

        try {
          const response = await apiPublic.post('/avaliacao-treinamento/avaliacao', formData)
          this.enviadoComSucesso = true
          this.$emit('avaliacao-enviada')
        } catch (error) {
          this.error = true
          this.errorMessage = error.response?.data?.message || 'Erro ao enviar o formulário. Por favor, tente novamente mais tarde.'
          this.$toast.error(this.errorMessage, 'Erro', {
            position: 'topRight',
            timeout: 5000,
          })
        } finally {
          this.enviando = false
        }
      }
    },
    fecharModal() {
      if (this.enviando) return
      this.$emit('fechar')
    },
    abrirModalTermos() {
      this.showModalTermos = true
    },
    closeModalTermos() {
      this.showModalTermos = false
      this.form.termos = false
    },
    aceitarTermos() {
      this.showModalTermos = false
      this.form.termos = true
    },
    async buscarCpfUsuario() {
      try {
        const userAuth = await this.$api.post('/app/auth/usuario', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (userAuth && userAuth.data) {
          this.cpf = userAuth.data.cpf
        }
      } catch (error) {
        if (this.$store.state.accessToken) {
          try {
            const decoded = jwtDecode(this.$store.state.accessToken)
            this.cpf = decoded.cpf || decoded.nu_cpf || null
          } catch (e) {
            // Erro ao decodificar token
          }
        }
      }
    },
    async preencherFuncaoDoUsuario() {
      const funcaoUsuario = this.$store.state.funcao
      
      if (!funcaoUsuario) {
        return
      }
      
      await this.$nextTick()
      
      let funcaoEncontrada = this.funcoes.find(
        f => f.value === funcaoUsuario || f.label === funcaoUsuario
      )
      
      if (!funcaoEncontrada) {
        funcaoEncontrada = this.funcoes.find(
          f => {
            const funcaoLower = funcaoUsuario.toLowerCase()
            const valueLower = f.value.toLowerCase()
            const labelLower = f.label.toLowerCase()
            
            return valueLower.includes(funcaoLower) || 
                   labelLower.includes(funcaoLower) ||
                   funcaoLower.includes(valueLower) ||
                   funcaoLower.includes(labelLower)
          }
        )
      }
      
      if (!funcaoEncontrada) {
        const mapeamentoFuncoes = {
          'Agente Comunitário de Saúde (ACS)': 'Agente Comunitário de Saúde',
          'Agente de Saúde (ACS)': 'Agente Comunitário de Saúde',
        }
        
        const funcaoMapeada = mapeamentoFuncoes[funcaoUsuario]
        if (funcaoMapeada) {
          funcaoEncontrada = this.funcoes.find(
            f => f.value === funcaoMapeada || f.label === funcaoMapeada
          )
        }
      }
      
      if (funcaoEncontrada) {
        this.form.funcao = funcaoEncontrada.value
        await this.$nextTick()
        this.$forceUpdate()
        await this.verificarFuncao({ value: funcaoEncontrada.value })
        await this.$nextTick()
        await this.preencherUBSDoUsuario()
      } else {
        this.form.funcao = funcaoUsuario
        await this.$nextTick()
        this.$forceUpdate()
        await this.verificarFuncao({ value: funcaoUsuario })
        await this.$nextTick()
        await this.preencherUBSDoUsuario()
      }
    },
    async preencherUBSDoUsuario() {
      const unidadeSaudeStore = this.$store.state.unidade_saude
      const cnesUsuario = this.$store.state.nu_cnes

      if (!unidadeSaudeStore && !cnesUsuario) {
        return
      }
      
      if (!this.ubs || this.ubs.length === 0) {
        await this.verificarFuncao({ value: this.form.funcao })
      }

      await this.$nextTick()
      
      let tentativas = 0
      while (this.ubs.length === 0 && tentativas < 10) {
        await new Promise(resolve => setTimeout(resolve, 200))
        tentativas++
      }

      const normalizar = (s) =>
        String(s || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toLowerCase()

      let ubsEncontrada = null
      if (unidadeSaudeStore) {
        const alvo = normalizar(unidadeSaudeStore)
        ubsEncontrada =
          this.ubs.find(u => normalizar(u?.no_ubs) === alvo) ||
          this.ubs.find(u => normalizar(u?.no_ubs).includes(alvo) || alvo.includes(normalizar(u?.no_ubs)))
      }

      if (!ubsEncontrada && cnesUsuario) {
        ubsEncontrada = this.ubs.find(u => String(u?.cnes || '').toLowerCase() === String(cnesUsuario).toLowerCase())
      }
      
      if (ubsEncontrada) {
        this.form.ubs = ubsEncontrada
      } else {
        let outros = this.ubs.find(u => String(u?.no_ubs || '').toLowerCase() === 'outros')
        if (!outros) {
          outros = { no_ubs: 'Outros' }
          this.ubs.push(outros)
        }
        this.form.ubs = outros
      }
    },
    preencherDataTreinamento() {
      if (!this.oficina) {
        return
      }

      const dataOficina = this.oficina.dataAtividade || this.oficina.data_atividade || this.oficina.inicio

      if (!dataOficina) {
        return
      }

      try {
        let dataFormatada = null
        
        // Se já está no formato YYYY-MM-DD, usar diretamente
        if (typeof dataOficina === 'string' && dataOficina.match(/^\d{4}-\d{2}-\d{2}$/)) {
          dataFormatada = dataOficina
        } else if (dataOficina.includes('-')) {
          // Extrair apenas a parte da data (YYYY-MM-DD) se houver hora
          dataFormatada = dataOficina.split(' ')[0].split('T')[0]
          
          // Verificar se está no formato correto YYYY-MM-DD
          if (!dataFormatada.match(/^\d{4}-\d{2}-\d{2}$/)) {
            // Tentar converter de DD/MM/YYYY para YYYY-MM-DD
            if (dataFormatada.includes('/')) {
              const partes = dataFormatada.split('/')
              if (partes.length === 3) {
                const [dia, mes, ano] = partes
                dataFormatada = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
              }
            } else {
              return
            }
          }
        } else {
          return
        }
        
        // Validar se a data é válida usando timezone local para evitar problemas
        const [ano, mes, dia] = dataFormatada.split('-')
        const dataObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
        if (isNaN(dataObj.getTime())) {
          return
        }

        // Garantir formato YYYY-MM-DD (formato ISO para input type="date")
        const dataISO = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
        this.form.dt_treinamento = dataISO
        // Formatar para exibição brasileira (dd/mm/aaaa)
        this.dataTreinamentoFormatada = `${dia.padStart(2, '0')}/${mes.padStart(2, '0')}/${ano}`
      } catch (error) {
        // Erro ao preencher data
        console.error('Erro ao formatar data:', error)
      }
    },
    abrirDatePickerTreinamento() {
      // Abre o date picker nativo ao clicar no ícone
      if (this.$refs.datePickerTreinamento) {
        this.$refs.datePickerTreinamento.showPicker?.() || this.$refs.datePickerTreinamento.click()
      }
    },
    onDatePickerTreinamentoChange(event) {
      // Quando o date picker nativo muda, atualiza a data formatada
      const dataValue = event.target.value
      if (dataValue) {
        const partes = dataValue.split('-')
        if (partes.length === 3) {
          // Formato brasileiro para exibição
          this.dataTreinamentoFormatada = `${partes[2]}/${partes[1]}/${partes[0]}`
          this.form.dt_treinamento = dataValue
        }
      }
    },
    formatarDataTreinamento(event) {
      let valor = event.target.value.replace(/\D/g, '')
      
      // Limitar a 8 dígitos (ddmmaaaa)
      if (valor.length > 8) {
        valor = valor.substring(0, 8)
      }
      
      // Formatar como dd/mm/aaaa
      let valorFormatado = valor
      if (valor.length > 2) {
        valorFormatado = valor.substring(0, 2) + '/' + valor.substring(2)
      }
      if (valor.length > 4) {
        valorFormatado = valorFormatado.substring(0, 5) + '/' + valorFormatado.substring(5)
      }
      
      this.dataTreinamentoFormatada = valorFormatado
      
      // Converter para formato ISO (YYYY-MM-DD) quando tiver 8 dígitos
      if (valor.length === 8) {
        const dia = valor.substring(0, 2)
        const mes = valor.substring(2, 4)
        const ano = valor.substring(4, 8)
        
        // Validar data
        const diaNum = parseInt(dia)
        const mesNum = parseInt(mes)
        const anoNum = parseInt(ano)
        
        if (diaNum >= 1 && diaNum <= 31 && mesNum >= 1 && mesNum <= 12 && anoNum >= 1900) {
          const dataISO = `${ano}-${mes}-${dia}`
          const dataObj = new Date(parseInt(ano), parseInt(mes) - 1, parseInt(dia))
          if (!isNaN(dataObj.getTime())) {
            this.form.dt_treinamento = dataISO
          }
        }
      } else {
        // Limpar o valor ISO se não estiver completo
        this.form.dt_treinamento = ''
      }
    },
    async preencherEstadoCidadeDoToken() {
      const cidadeEstado = this.$store.state.cidade
      
      if (!cidadeEstado || typeof cidadeEstado !== 'string') {
        return
      }

      try {
        const partes = cidadeEstado.split(' - ')
        
        if (partes.length === 2) {
          const nomeMunicipio = partes[0].trim()
          const uf = partes[1].trim()
          
          this.form.estadoTexto = uf
          this.form.cidadeTexto = nomeMunicipio
          this.form.municipioCompleto = cidadeEstado
          
          const estadoEncontrado = this.estados.find(e => e.uf === uf)
          
          if (estadoEncontrado) {
            this.form.estado = estadoEncontrado
            
            try {
              await this.buscarCidades(estadoEncontrado)
              await this.$nextTick()
              
              let tentativas = 0
              while (this.loading && tentativas < 10) {
                await new Promise(resolve => setTimeout(resolve, 100))
                tentativas++
              }
              
              const cidadeEncontrada = this.cidades.find(
                c => c.no_municipio.toUpperCase() === nomeMunicipio.toUpperCase()
              )
              
              if (cidadeEncontrada) {
                this.form.cidade = cidadeEncontrada
                this.form.cidadeSelecionada = cidadeEncontrada
                this.verificarCidade(cidadeEncontrada)
              } else {
                this.form.cidade = { no_municipio: nomeMunicipio }
                this.form.cidadeSelecionada = { no_municipio: nomeMunicipio, co_ibge: this.$store.state.cod_ibge || '' }
              }
            } catch (error) {
              this.form.cidade = { no_municipio: nomeMunicipio }
              this.form.cidadeSelecionada = { no_municipio: nomeMunicipio, co_ibge: this.$store.state.cod_ibge || '' }
            }
          } else {
            this.form.estado = { uf: uf }
            this.form.cidade = { no_municipio: nomeMunicipio }
            this.form.cidadeSelecionada = { no_municipio: nomeMunicipio, co_ibge: this.$store.state.cod_ibge || '' }
          }
        }
      } catch (error) {
        // Erro ao preencher estado e cidade
      }
    }
  }
}
</script>

<style scoped>
.modal-avaliacao-wrapper {
  z-index: 9999 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.modal-avaliacao-wrapper .modal-dialog {
  z-index: 10000 !important;
  position: relative;
  margin: 1.75rem auto;
}

.modal-avaliacao {
  max-width: 90%;
  position: relative;
  z-index: 10001 !important;
}

.modal-body {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}

.form-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;
}

.form-group {
  flex: 1;
  margin-right: 10px;
  text-align: left;
  padding-top: 10px;
}

.ml-3 {
  margin-left: 10px;
}

label {
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 14px;
  padding-bottom: 8px;
}

select.form-control, input.form-control, textarea.form-control {
  width: 100%;
  padding: 8px;
  font-size: 14px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.text-danger {
  color: red;
  font-size: 12px;
  display: block;
  margin-top: 5px;
}

.input-date-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  max-width: 200px;
}

.input-date-wrapper .date-input {
  width: 100%;
  padding-right: 35px;
}

.date-picker-hidden {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}

.date-icon {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
  font-size: 1.1rem;
  pointer-events: auto;
  z-index: 1;
}

.date-icon:hover {
  color: #495057;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
  gap: 10px;
}

.btn {
  height: 40px;
  padding: 8px 20px;
  font-size: 14px;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  min-width: 120px;
}

.btn-proximo {
  margin-left: auto;
}

.btn-primary {
  background-color: #0fafd7;
  color: white;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #5a6268;
  color: white;
}

.btn-primary:hover {
  color: #fff !important;
  background-color: #0069d9;
  border-color: #0062cc;
}

.btn-active {
  background-color: #0fafd7 !important;
  color: white !important;
}

.link-termos {
  color: #0fafd7;
  text-decoration: underline;
  cursor: pointer;
}

.checkbox-termos {
  display: block;
  align-items: center;
  margin-top: 20px;
}

.checkbox-termos input {
  margin-right: 10px;
}

.btn-group {
  display: flex;
  gap: 10px;
}

.vue-select {
  width: 100%;
}

.mt-3 {
  margin-top: 16px;
}

.small {
  font-size: 12px;
  color: #6c757d;
}

.info-badge {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  min-height: 48px;
  transition: all 0.2s ease;
}

.info-badge:hover {
  background-color: #e9ecef;
  border-color: #0fafd7;
}

.info-badge i {
  font-size: 18px;
  color: #0fafd7;
  flex-shrink: 0;
}

.info-value {
  font-size: 15px;
  font-weight: 500;
  color: #212529;
  margin-left: 8px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 12px;
  font-size: 16px;
  color: #6c757d;
  z-index: 1;
  pointer-events: none;
}

.input-with-icon {
  padding-left: 38px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.input-with-icon:focus {
  border-color: #0fafd7;
  box-shadow: 0 0 0 0.2rem rgba(15, 175, 215, 0.25);
  outline: none;
}

.form-group label i {
  color: #0fafd7;
  font-size: 14px;
}

@media (max-width: 768px) {
  .form-row {
    display: block;
  }
  
  .ml-3 {
    margin-left: 0 !important;
  }
  
  .form-group {
    margin-right: 0;
    margin-bottom: 15px;
  }
  
  .info-badge {
    padding: 10px 12px;
    min-height: 44px;
  }
  
  .info-badge i {
    font-size: 16px;
  }
  
  .info-value {
    font-size: 14px;
  }
  
  .input-with-icon {
    padding-left: 35px;
  }
  
  .input-icon {
    font-size: 14px;
    left: 10px;
  }
}
</style>

<style>
.modal-avaliacao-wrapper {
  z-index: 9999 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
}

.modal-backdrop-avaliacao {
  z-index: 9998 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

.modal-avaliacao-wrapper .modal-dialog {
  z-index: 10000 !important;
}

.modal-avaliacao-wrapper .modal-content {
  z-index: 10001 !important;
}

.modal-avaliacao .modal-header {
  border-bottom: 1px solid #dee2e6;
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.modal-avaliacao .modal-header .close {
  margin: 0;
  padding: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.modal-avaliacao .modal-header .close:hover {
  opacity: 0.75;
}
</style>
